import React from 'react';
import { BoxIcon } from 'lucide-react';
interface MetricCardProps {
  title: string;
  value: string | number;
  change?: string | number;
  isPositive?: boolean;
  icon: BoxIcon;
  color?: string;
}
const MetricCard = ({
  title,
  value,
  change,
  isPositive = true,
  icon: Icon,
  color = 'bg-gray-100'
}: MetricCardProps) => {
  return <div className="rounded-lg border border-gray-200 bg-white p-6" data-id="element-525">
      <div className="flex items-center" data-id="element-526">
        <Icon className="h-5 w-5 mr-3 text-gray-700" data-id="element-527" />
        <div data-id="element-528">
          <p className="text-sm font-medium text-gray-500" data-id="element-529">{title}</p>
          <h3 className="mt-1 text-2xl font-semibold" data-id="element-530">{value}</h3>
          {change && <div className="mt-1 flex items-center" data-id="element-531">
              <span className={`text-xs font-medium ${isPositive ? 'text-greenback' : 'text-red-600'}`} data-id="element-532">
                {isPositive ? '+' : ''}
                {change}
              </span>
              <span className="ml-1 text-xs text-gray-500" data-id="element-533">vs mese scorso</span>
            </div>}
        </div>
      </div>
    </div>;
};
export default MetricCard;